import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";
import { ProductsTableColumn } from "./ProductsTableColumn";
// import { IconTrash01 } from "@pentabd/icons";

type Props = {
  handleProductsRemove: (id: number | string) => void;
  selectedProducts: any[] | [];
};
function ProductsTable({ handleProductsRemove, selectedProducts }: Props) {
  const { t } = useTranslation();

  return (
    <div className="mt-10">
      {/* <div className="mb-10">
        <Text className="fw-bold">
          {t("INVENTORY_REQUISITION.REQUISITION_DETAILS.SELECTED_PRODUCTS")}
        </Text>
      </div> */}
      <Table
        header={{
          title: t(
            "INVENTORY_REQUISITION.REQUISITION_DETAILS.SELECTED_PRODUCTS",
          ),
        }}
        columns={ProductsTableColumn(t, handleProductsRemove) as any}
        rows={selectedProducts || []}
        // remove={{
        //   customIcon: <IconTrash01 size={24} fill="danger" />,
        //   onClick: (id) => {
        //     handleProductsRemove(id);
        //   },
        // }}
      />
    </div>
  );
}

export default ProductsTable;
